export default function roomExamEventListener(room) {
  return store => {
    room.addEventListeners({
      room_exam_ready: (e) => {
        store.commit('exam/SET_EXAM', e.data);
      },
      room_exam_start: (e) => {
        store.commit('exam/SET_EXAM', e.data);
      },
      room_exam_end: (e) => {
        store.commit('exam/SET_EXAM');
        store.commit('exam/CLEAR_USER_ANSWER_LIST');
      },
      room_exam_user_create: (e) => {
        store.commit('exam/SET_USER', e.data);
      },
      room_exam_user_submit: (e) => {
        store.commit('exam/SET_USER_ANSWER_LIST', e.data);
      },
      room_exam_user_answers: (e) => {
        store.commit('exam/SET_USER_ANSWER_LIST', e.data);
      },
      room_exam_user_complete: (e) => {
        store.commit('exam/COMPLETE_USER', e.data);
      }
    });
  }
}
